export default "/images/cover4.jpg?071e57489e7b5033f53cc739cae1067a";